import { watchEntities, findEntities, getEntity, updateEntity, deleteEntity, createEntity, unwatchEntities } from './EntitiesSagas';
import { RegionsActions } from '../reducers/RegionsRedux'

export function* watchRegions(api) {
  yield watchEntities(api, 'region', RegionsActions)
}

export function* unwatchRegions(api){
  yield unwatchEntities(api, 'region', RegionsActions)
}

export function* findRegions(api, action) {
  yield findEntities(api, 'region', RegionsActions, action)
}

export function* getRegion(api, action) {
  yield getEntity(api, RegionsActions, action)
}

export function* updateRegion(api, action) {
  yield updateEntity(api, RegionsActions, action)
}

export function* deleteRegion(api, action) {
  yield deleteEntity(api, RegionsActions, action)
}

export function* createRegion(api, action) {
  yield createEntity(api, RegionsActions, action)
}
